import React from 'react'
import { MDXTag } from '@mdx-js/tag'


import DefaultLayout from "/Users/raphael.benitte/projects/edikit/website/src/components/DocLayout.js"
import FormInputDemo from '../../../components/demos/FormInput'
import FormSelectDemo from '../../../components/demos/FormSelect'

export default ({components, ...props}) => <MDXTag name="wrapper" Layout={DefaultLayout} layoutProps={props} components={components}>


<MDXTag name="h1" components={components} props={{"id":"form"}}><MDXTag name="a" components={components} parentName="h1" props={{"ariaHidden":"true","href":"#form"}}><MDXTag name="span" components={components} parentName="a" props={{"className":"icon icon-link"}}></MDXTag></MDXTag>{`Form`}</MDXTag>
<MDXTag name="p" components={components}><MDXTag name="a" components={components} parentName="p" props={{"href":"#input"}}>{`input`}</MDXTag>{` |
`}<MDXTag name="a" components={components} parentName="p" props={{"href":"#select"}}>{`select`}</MDXTag></MDXTag>
<MDXTag name="h2" components={components} props={{"id":"input"}}><MDXTag name="a" components={components} parentName="h2" props={{"ariaHidden":"true","href":"#input"}}><MDXTag name="span" components={components} parentName="a" props={{"className":"icon icon-link"}}></MDXTag></MDXTag>{`Input`}</MDXTag>
<FormInputDemo/>
<MDXTag name="h2" components={components} props={{"id":"select"}}><MDXTag name="a" components={components} parentName="h2" props={{"ariaHidden":"true","href":"#select"}}><MDXTag name="span" components={components} parentName="a" props={{"className":"icon icon-link"}}></MDXTag></MDXTag>{`Select`}</MDXTag>
<FormSelectDemo/></MDXTag>

export const _frontmatter = {};

  